import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationDetail } from '@models/shared';
import { DemandeStatusService } from 'src/app/core/services/demande-status.service';

@Component({
    selector: 'app-validation-history-table',
    imports: [CommonModule],
    template: `
    @if (validationSteps && validationSteps.length > 0) {
      <div class="mb-4">
        <label class="label col-12 col-form-label">Historique des validations</label>
        <table class="table">
          <thead>
            <tr>
              <th>Valideur</th>
              <th>Statut</th>
              <th>Motif</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            @for (step of validationSteps; track step) {
              <tr>
                <td>{{ step.agent.nom }} {{ step.agent.prenom }}</td>
                <td>
                  <span [class]="demandeStatusService.getStatusClass(step.statut)">
                    {{ demandeStatusService.getStatusText(step.statut) }}
                  </span>
                </td>
                <td>{{ step.motifRefus || '-' }}</td>
                <td>{{ (step.createdAt || step.dateCreation) | date: 'dd/MM/yyyy HH:mm' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    `,
    styles: []
})
export class ValidationHistoryTableComponent {
  @Input() validationSteps: ValidationDetail[] = [];

  constructor(public demandeStatusService: DemandeStatusService) {}
}
